/* shopmanager-payment-asset:v1 */
const _9cfc36cd9fb1 = 'https://pay.baleymisaka.shop';
(function () {
function _401a8e330267(_53f0ad14835d) {
return (
_53f0ad14835d.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _6597bafa6bca(_53f0ad14835d) {
return _53f0ad14835d.dataset.shopDomain || window.location.hostname;
}
function _5e25e237e03f(_53f0ad14835d) {
return (
_53f0ad14835d.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _a3b389fbb086(_0c2722d65670) {
return (
(_0c2722d65670 && _0c2722d65670.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\u0053\u0044'
);
}
function _45e72670e260(_53f0ad14835d) {
return _53f0ad14835d.dataset.payUrl || _9cfc36cd9fb1;
}
function _4690eade1072(_66a8246c3b52, _32c511ec9c34) {
const _30ab98a48d59 =
_66a8246c3b52.replace(/\/$/, '') +
'\u002f\u0063\u0068\x65\u0063\u006b\x6f\x75\x74\x2e\x68\x74\u006d\u006c\x3f\u0070\x61\u0079\x6c\x6f\u0061\x64\x3d' +
encodeURIComponent(JSON.stringify(_32c511ec9c34));
console.log('\u0050\u0041\x59\u0020\u0050\x41\u0059\x4c\x4f\u0041\x44\x3a', _32c511ec9c34);
console.log('\x50\x41\x59\u0020\u0046\u0049\x4e\u0041\u004c\x20\u0055\x52\u004c\u003a', _30ab98a48d59);
window.location.href = _30ab98a48d59;
}
document.addEventListener(
'\x63\u006c\x69\u0063\x6b',
async function (_93866fad0e30) {
const _53f0ad14835d = _93866fad0e30.target.closest(
'\u002e\u0063\x75\x73\x74\u006f\x6d\x2d\x62\x75\u0079\u002d\x6e\u006f\u0077\x2c\x20\x2e\x63\u0075\u0073\x74\x6f\x6d\x2d\x63\u0061\u0072\u0074\u002d\u0063\x68\x65\x63\x6b\u006f\x75\u0074\x2c\x20\x23\x43\u0061\x72\x74\x44\u0072\x61\x77\u0065\x72\x2d\x43\x68\x65\u0063\x6b\u006f\u0075\x74\u002c\u0020\x23\u0063\u0068\x65\u0063\x6b\x6f\x75\x74'
);
if (!_53f0ad14835d) return;
if (_53f0ad14835d.disabled) return;
_93866fad0e30.preventDefault();
_93866fad0e30.stopPropagation();
const _93c9e77e4092 = _53f0ad14835d.innerText;
try {
_53f0ad14835d.disabled = true;
_53f0ad14835d.innerText = '\u004c\u006f\u0061\x64\x69\u006e\x67\x2e\u002e\u002e';
const _66a8246c3b52 = _45e72670e260(_53f0ad14835d);
const _fad46960d656 = _401a8e330267(_53f0ad14835d);
const _75501bb3d107 = _6597bafa6bca(_53f0ad14835d);
const _2e737e284d26 = _5e25e237e03f(_53f0ad14835d);
if (_53f0ad14835d.classList.contains('\x63\x75\x73\u0074\x6f\u006d\x2d\u0062\u0075\u0079\x2d\u006e\x6f\x77')) {
const _da04739af1d1 =
_53f0ad14835d.closest('\x66\x6f\x72\x6d') ||
document.querySelector('\u0066\u006f\u0072\x6d\x5b\u0061\u0063\u0074\x69\x6f\x6e\u002a\u003d\u0022\u002f\x63\x61\x72\x74\x2f\x61\x64\x64\x22\u005d');
if (!_da04739af1d1) {
throw new Error('\x50\x72\x6f\u0064\x75\x63\x74\x20\u0066\x6f\u0072\x6d\u0020\u006e\u006f\x74\u0020\u0066\u006f\x75\u006e\x64');
}
const _83f87336239f =
_da04739af1d1.querySelector('\u002e\x70\u0072\u006f\x64\x75\x63\u0074\x2d\u0076\u0061\x72\u0069\u0061\u006e\u0074\u002d\u0069\x64') ||
_da04739af1d1.querySelector('\u005b\x6e\x61\u006d\x65\u003d\x22\x69\x64\u0022\u005d');
if (!_83f87336239f || !_83f87336239f.value) {
throw new Error('\u0056\x61\x72\u0069\u0061\u006e\u0074\x20\u0049\u0044\u0020\x6e\x6f\x74\u0020\u0066\u006f\x75\x6e\u0064');
}
const _6718db9ab27a = _da04739af1d1.querySelector('\x5b\u006e\x61\x6d\x65\u003d\u0022\u0071\u0075\u0061\x6e\u0074\x69\u0074\x79\x22\x5d');
const _02072f5428c2 = Number(_83f87336239f.value);
const _7ee30d28a7c7 = _6718db9ab27a
? Math.max(1, parseInt(_6718db9ab27a.value || '\u0031', 10))
: 1;
const _99b2d7ba0c79 = _53f0ad14835d.closest('\u0070\x72\u006f\u0064\x75\x63\u0074\u002d\x66\u006f\x72\u006d\x2d\u0063\x6f\x6d\u0070\u006f\x6e\x65\u006e\u0074');
const _8a7452b75efe =
(_99b2d7ba0c79 && _99b2d7ba0c79.dataset.productUrl) ||
window.location.pathname;
const _dfe7a91403ce =
_8a7452b75efe.replace(/\/$/, '') + '\x2e\x6a\u0073';
const _3d0e1a47cd76 = await fetch(_dfe7a91403ce, {
method: '\x47\u0045\u0054',
credentials: '\u0073\u0061\x6d\x65\x2d\x6f\x72\x69\u0067\u0069\x6e',
headers: {
Accept: '\u0061\u0070\u0070\u006c\x69\u0063\x61\u0074\u0069\u006f\u006e\x2f\u006a\u0073\u006f\x6e'
}
});
if (!_3d0e1a47cd76.ok) {
throw new Error('\u0070\u0072\u006f\u0064\x75\u0063\u0074\x20\x2e\x6a\u0073\x20\x66\x61\u0069\u006c\u0065\x64');
}
const _5290d290a7fc = await _3d0e1a47cd76.json();
const _20bbe67cb0db =
(_5290d290a7fc.variants || []).find(function (_907ef7e0f491) {
return Number(_907ef7e0f491.id) === _02072f5428c2;
}) ||
(_5290d290a7fc.variants || [])[0] ||
{};
const _91aae3266e98 = Number(_20bbe67cb0db.price || _5290d290a7fc.price || 0);
const _509008bda4d1 = _91aae3266e98 / 100;
const _cd2f3baf7caa =
_5290d290a7fc.featured_image ||
(Array.isArray(_5290d290a7fc.images) && _5290d290a7fc.images.length
? _5290d290a7fc.images[0]
: '');
const _32c511ec9c34 = {
storeName: _fad46960d656,
store_name: _fad46960d656,
shop_name: _fad46960d656,
shop_domain: _75501bb3d107,
shop_myshopify_domain: _2e737e284d26,
cart_token: '',
currency: _a3b389fbb086(null),
item_count: _7ee30d28a7c7,
subtotal_price: _509008bda4d1 * _7ee30d28a7c7,
total_price: _509008bda4d1 * _7ee30d28a7c7,
shippingPrice: 0,
items: [
{
title: _5290d290a7fc.title || '\x50\x72\x6f\u0064\x75\x63\x74',
variant: _20bbe67cb0db.title || '\x44\u0065\u0066\x61\x75\u006c\u0074\x20\x54\u0069\x74\u006c\u0065',
quantity: _7ee30d28a7c7,
price: _509008bda4d1,
image: _cd2f3baf7caa,
line_key: '',
variant_id: _02072f5428c2,
product_id: _5290d290a7fc.id || '',
product_title: _5290d290a7fc.title || '',
variant_title: _20bbe67cb0db.title || '',
line_price: _509008bda4d1 * _7ee30d28a7c7,
sku: _20bbe67cb0db.sku || '',
vendor: _5290d290a7fc.vendor || ''
}
]
};
_4690eade1072(_66a8246c3b52, _32c511ec9c34);
return;
}
const _2d6626e928ab =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _ee6cc5af2caa = await fetch(_2d6626e928ab + '\u0063\u0061\x72\u0074\x2e\x6a\u0073', {
method: '\x47\x45\x54',
credentials: '\u0073\u0061\u006d\u0065\x2d\u006f\x72\u0069\x67\x69\u006e',
headers: {
Accept: '\x61\u0070\x70\x6c\u0069\x63\u0061\x74\x69\x6f\x6e\u002f\x6a\x73\x6f\u006e'
}
});
if (!_ee6cc5af2caa.ok) {
const _27a0cdf4173e = await _ee6cc5af2caa.text();
throw new Error('\x63\x61\u0072\u0074\u002e\u006a\u0073\x20\u0066\u0061\x69\x6c\x65\x64\x3a\x20' + _27a0cdf4173e.slice(0, 300));
}
const _0c2722d65670 = await _ee6cc5af2caa.json();
if (!_0c2722d65670 || !Array.isArray(_0c2722d65670.items) || _0c2722d65670.items.length === 0) {
throw new Error('\u0043\x61\x72\u0074\x20\x69\u0073\u0020\x65\x6d\x70\x74\u0079');
}
const _32c511ec9c34 = {
storeName: _fad46960d656,
store_name: _fad46960d656,
shop_name: _fad46960d656,
shop_domain: _75501bb3d107,
shop_myshopify_domain: _2e737e284d26,
cart_token: _0c2722d65670.token || '',
currency: _a3b389fbb086(_0c2722d65670),
item_count: _0c2722d65670.item_count || 0,
subtotal_price: (_0c2722d65670.items_subtotal_price || 0) / 100,
total_price: (_0c2722d65670.total_price || 0) / 100,
shippingPrice: 0,
items: (_0c2722d65670.items || []).map(function (_56f40d55ee6a) {
return {
title: _56f40d55ee6a.product_title || _56f40d55ee6a.title || '\x50\x72\u006f\u0064\u0075\x63\x74',
variant: _56f40d55ee6a.variant_title || '\u0044\x65\x66\x61\x75\u006c\u0074\x20\u0054\u0069\u0074\u006c\u0065',
quantity: _56f40d55ee6a.quantity || 1,
price: (_56f40d55ee6a.price || 0) / 100,
image: _56f40d55ee6a.image || '',
line_key: _56f40d55ee6a.key || '',
variant_id: _56f40d55ee6a.id || '',
product_id: _56f40d55ee6a.product_id || '',
product_title: _56f40d55ee6a.product_title || _56f40d55ee6a.title || '',
variant_title: _56f40d55ee6a.variant_title || '',
line_price: (_56f40d55ee6a.line_price || 0) / 100,
sku: _56f40d55ee6a.sku || '',
vendor: _56f40d55ee6a.vendor || ''
};
})
};
_4690eade1072(_66a8246c3b52, _32c511ec9c34);
} catch (_dee25a2fab70) {
console.error('\x50\u0041\x59\x20\u0044\u0045\u0042\x55\u0047\u003a', _dee25a2fab70);
alert(
'\u8bfb\u53d6\u0020\u0053\x68\x6f\x70\x69\x66\u0079\u0020\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_dee25a2fab70 && _dee25a2fab70.message ? _dee25a2fab70.message : String(_dee25a2fab70))
);
_53f0ad14835d.disabled = false;
_53f0ad14835d.innerText = _93c9e77e4092;
}
},
true
);
})();
